import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImagesSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="images-sparkle, photos, pictures, shot, generate"><path d="M19.75 19.75L14 14L12 16L8 12L4.25 15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 3.75H3.75V20.25H20.25V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconImagesSparkle;
